export interface LookupType {
  id: number;
  typeCode: string;
  typeName: string;
  description?: string;
  isActive: boolean;
  createdAt: Date;
  updatedAt?: Date;
  values: LookupValue[];
}

export interface LookupValue {
  id: number;
  lookupTypeId: number;
  code: string;
  name: string;
  description?: string;
  sortOrder: number;
  isDefault: boolean;
  isActive: boolean;
  createdAt: Date;
  updatedAt?: Date;
}

/**
 * Option for dropdowns/filters using lookup values
 */
export interface LookupOption {
  value: string;
  label: string;
}

/**
 * Known lookup type codes
 */
export const LookupTypeCodes = {
  RESOURCE_CAPACITY_STATUS: 'RESOURCE_CAPACITY_STATUS',
  REQUEST_STATUS: 'REQUEST_STATUS',
  REQUEST_TYPE: 'REQUEST_TYPE',
  TIME_OFF_REQUEST_TYPE: 'TIME_OFF_REQUEST_TYPE',
  TIME_OFF_REQUEST_STATUS: 'TIME_OFF_REQUEST_STATUS',
  SENIORITY: 'SENIORITY',
  FEEDBACK_CATEGORY: 'FEEDBACK_CATEGORY',
  RESOURCE_VISIBILITY_MODE: 'RESOURCE_VISIBILITY_MODE',
  SKILLS: 'SKILLS',
  JURISDICTIONS: 'JURISDICTIONS',
  LANGUAGES: 'LANGUAGES',
  INTERESTS: 'INTERESTS',
  SUB_PRACTICE: 'SUB_PRACTICE',
  ASSIGNED_RESOURCE_STATUS: 'ASSIGNED_RESOURCE_STATUS',
} as const;

export type LookupTypeCode =
  (typeof LookupTypeCodes)[keyof typeof LookupTypeCodes];
